__turbopack_context__.v({
  "icon": "PassTypesSelectorFormBlock-module__AxxAyW__icon",
});
